import { miniCartState } from './state';
import * as mutations from './mutations';
import * as actions from './actions';

export default (placeholder) => ({
  state: miniCartState(placeholder),
  mutations,
  actions,
  namespaced: true,
});
